export default __webpack_public_path__ + "static/media/ToyotaType-Regular.1cf090dc.ttf";